import { useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CandidateClaimForm from "../components/CandidateClaimForm";

const ClaimCandidateProfile = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  const candidate = useMemo(
    () => ({
      id: params.get("candidateId") || "",
      name: params.get("name") || "",
      position: params.get("position") || "MLA",
      constituency: params.get("constituency") || "",
      state: params.get("state") || "",
      district: params.get("district") || "",
      party: params.get("party") || "",
      isClaimed: false,
    }),
    [params],
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-100 via-white to-green-100 px-4 py-10">
      <div className="mx-auto max-w-3xl rounded-[2rem] border border-orange-100 bg-white p-8 shadow-xl shadow-orange-100/60">
        <div className="mb-8 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-slate-400">
            Candidate Ownership
          </p>
          <h1 className="mt-2 text-3xl font-black tracking-tight text-slate-900">
            Claim Candidate Profile
          </h1>
          <p className="mt-3 text-sm text-slate-600">
            Submit your details and supporting files. Admin approval will turn this same account into a verified candidate login.
          </p>
        </div>

        <CandidateClaimForm
          candidate={candidate}
          submitLabel="Submit Ownership Claim"
          onCancel={() => navigate(-1)}
          onSuccess={() => navigate(`/candidate/${encodeURIComponent(candidate.name || "")}`)}
        />
      </div>
    </div>
  );
};

export default ClaimCandidateProfile;
